( function () {
	'use strict';

	function UpcomingSchedsCtrl ( logger, moment, scheduleservice ) {
		var self = this;

		self.events = angular.copy( self.events );
		self.title  = 'Upcoming Schedules';

		function getStartTime ( date ) {
			return moment( date ).format( 'hh:mm A' );
		}

		function getDayOfWeek ( date ) {
			return moment( date ).format( 'dddd' );
		}

		function activate () {
			logger.info( 'Activated Upcoming Schedules View' );
		}

		activate();

		self.getStartTime    = getStartTime;
		self.getDayOfWeek    = getDayOfWeek;
		self.confirmStartObs = scheduleservice.confirmStartObs;
	}

	angular
		.module( 'app.schedules' )
		.controller( 'UpcomingSchedsCtrl', UpcomingSchedsCtrl );

	UpcomingSchedsCtrl.$inject = [ 'logger', 'moment', 'scheduleservice' ];
} )( );
